































// 3rd party libs
import Vue, {
    PropType,
} from 'vue';

interface MenuItem {
    text: string;
    action: () => void;
}

interface IconConfig {
    name: string;
    color?: string;
}

export default Vue.extend({
    name: 'context-menu',
    props: {
        items: {
            type: Array as PropType<MenuItem[]>,
            required: false,
            default: () => ([]),
        },

        iconConfig: {
            type: Object as PropType<IconConfig>,
            default: () => ({
                name: 'info',
                color: '#2c67d5',
            }),
        },
    },
    data() {
        return {
            showMenu: false,
            isRightPos: false,
        };
    },
    mounted() {
        // Possible improvement - Run on window resize, preferably debounced
        this.$nextTick(() => {
            const { x = 0 } = (this.$refs?.contextMenuIcon.getBoundingClientRect()) ?? {};

            this.isRightPos = x > (window.innerWidth / 2);
        });
    },
    methods: {
        onClickItem(item: MenuItem): void {
            this.showMenu = false;
            item.action();
            this.$emit('clickItem', item);
        },
    },
});
